import { render, staticRenderFns } from "./AppPreview.vue?vue&type=template&id=28e8a583&scoped=true"
import script from "./AppPreview.vue?vue&type=script&lang=ts"
export * from "./AppPreview.vue?vue&type=script&lang=ts"
import style0 from "./AppPreview.vue?vue&type=style&index=0&id=28e8a583&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8a583",
  null
  
)

export default component.exports